var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgSheetIcon = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, className: "lucide lucide-sheet-icon lucide-sheet", viewBox: "0 0 24 24" }, props, { children: [_jsx("rect", { width: 18, height: 18, x: 3, y: 3, rx: 2, ry: 2 }), _jsx("path", { d: "M3 9h18M3 15h18M9 9v12M15 9v12" })] }))); };
export default SvgSheetIcon;
